/**
 * U2-S1b — validation du chargement ticket avant ouverture modal SAV (handoff U1).
 */

/**
 * @param {object} p
 * @param {number} p.loadGen
 * @param {number} p.activeGen
 * @param {string} p.shopAtStart
 * @param {string} p.shopNow
 * @param {string} p.commandeId
 * @param {{ id?: string } | null} p.ticket
 * @returns {{ ok: true } | { ok: false, reason: 'stale'|'shop_changed'|'ticket_missing'|'ticket_mismatch' }}
 */
export function validateWebEncaisseUnifiedHandoffTicketLoad({
  loadGen,
  activeGen,
  shopAtStart,
  shopNow,
  commandeId,
  ticket,
}) {
  if (loadGen !== activeGen) {
    return { ok: false, reason: 'stale' };
  }
  if (shopAtStart !== shopNow) {
    return { ok: false, reason: 'shop_changed' };
  }
  if (!ticket?.id) {
    return { ok: false, reason: 'ticket_missing' };
  }
  if (ticket.id !== commandeId) {
    return { ok: false, reason: 'ticket_mismatch' };
  }
  return { ok: true };
}
